var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSeatNotAvailable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "asiento_nodisponible",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 25,
    height: 25,
    transform: "translate(756 1192)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_42",
    "data-name": "Mask Group 42",
    transform: "translate(-756 -1192)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M303,24.087a3.121,3.121,0,0,0-3.112-2.952H288.862v.445h-4.048a2.733,2.733,0,0,0-2.73,2.73V39.483a2.733,2.733,0,0,0,2.73,2.73h4.355v.336h10.714a3.124,3.124,0,0,0,3.12-3.12v-.382a1.127,1.127,0,0,0,.729-1.053V25.142A1.126,1.126,0,0,0,303,24.087M284.814,41.17a1.689,1.689,0,0,1-1.688-1.688V24.31a1.689,1.689,0,0,1,1.688-1.688h4.048v.336h11.022a1.3,1.3,0,0,1,1.272,1.054h-.4a1.129,1.129,0,0,0-1.129,1.129V37.993a1.129,1.129,0,0,0,1.129,1.129h.421v.306a1.3,1.3,0,0,1-1.3,1.3H289.169v.446Z",
    transform: "translate(475.591 1172.658)",
    fill: "#a7a7a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeatNotAvailable);
export default __webpack_public_path__ + "static/media/icon_seat_not_available.ad99899315c7588ea836e653ac5be748.svg";
export { ForwardRef as ReactComponent };